import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { logout } from '../redux/slices/authSlice';

const AUTO_LOGOUT_TIME = 30 * 60 * 1000; // 10 minutes in ms

export default function useAutoLogout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        dispatch(logout());
        alert("Session expired. You have been logged out.");
        navigate("/login", { replace: true });
      }, AUTO_LOGOUT_TIME);
    };

    // Track user activity
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);
    window.addEventListener("click", resetTimer);

    resetTimer(); // start immediately

    return () => {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, [navigate, dispatch]);
}
